webClient.controller('B2B.WorldTourQuotation', ['$scope', '$window', '$timeout', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', function ($scope, $window, $timeout, tseApiClient, tseUtil, airHelper) {
    $window.$scope = $scope;
    $scope._util = tseUtil;
    $scope.getText = function (key) { return window.culture.texts[key]; };

    //Stops:
    // 3 -> 454
    // 4 -> 620
    // 5 -> 764
    // 6 -> 1130
    $scope.stops = parseInt(tseUtil.Location.getQueryStringVar("s"), 8) / 100;

    //Cities Arrays
    $scope.auxfranceCities = ["Paris", "Bordeaux", "Lyon", "Marseille", "Nice", "Toulouse"];

    $scope.auxfranceLessCities = ["Paris", "Lyon", "Marseille", "Nice", "Toulouse"];

    $scope.franceCities = ($scope.stops == 3 || $scope.stops == 4) ? $scope.auxfranceCities : $scope.auxfranceLessCities;

    $scope.asiaCities = ["Tokyo(Japon)", "Shanghai (Chine)", "Hong Kong (Chine)"];

    $scope.nzCities = ["Auckland (Nouvelle-Zélande)", "Christchurch (Nouvelle Zélande)", "Wellington (Nouvelle-Zélande)"];

    $scope.usaCities = ["Los Angeles (Etats-Unis)", "San Francisco (Etats-Unis)", "Houston (Etats-Unis)", "Vancouver (Canada)"];

    $scope.pacificCities = ["Nouméa (Nouvelle-Calédonie)", "Tongatapu (Tonga)", "Apia Faleolo (Samoa)", "Nadi (Fijji)", "Rarotonga (iles Cook)"];

    $scope.pacificLessCities = ["Rarotonga (Iles Cook)", "Nadi (Fiji) ", "Papeete (Tahiti)", " Honolulu (Hawaii)"];

    $scope.australiaCities = ["Sydney (Australie)", "Melbourne (Australie)", "Brisbane (Australie)", "Adelaide (Australie)", "Cairns (Australie)", "Gold Coast (Australie)", "Perth (Australie)"];

    $scope.cabinClasses = [{ name: 'Economique', value: 'Y' }, { name: 'Business', value: 'C' }];

    //Agency payment mode: This parameter is used to change wordings to agencies
    if ($window && $window.site && $window.site.loginInfo && $window.site.loginInfo.Client)
        $scope.agencyPaymentMethod = $window.site.loginInfo.Client.PaymentMode;

    //DateMin by default for first itinerary
    $scope.dateMin = moment();
    $scope.dateMin = $scope.dateMin.add('15', 'days');
    $scope.dateMin = moment($scope.dateMin).format('DD/MM/YYYY');

    //DateMax by default for first itinerary
    $scope.dateMax = moment();
    $scope.dateMax = $scope.dateMax.add('1', 'year');
    $scope.dateMax = moment($scope.dateMax).format('DD/MM/YYYY');

    //Cities
    $scope.auxCities = {};

    //Dates
    $scope.auxDates = {};

    //Flags
    $scope.addOnAustralia = false;
    $scope.addOnPacifique = false;

    //Rest Api Client Object
    $scope.apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);

    //WorldTour Data
    $scope.worldTourQuotationData = {
        reference: '', name: '', mail: '', phone: '', comment: '', cabinClass: 'Y',
        passengers: [{ title: '', firstName: '', lastName: '', birthDate: '' }]
    };
    $scope.worldTourQuotationData.passengers.push({ type: '', firtsName: '', lastName: '', birthDate: '' });
    $scope.worldTourQuotationData.reference = $scope.stops == 3 ? '00001' : $scope.stops == 4 ? '00002' : $scope.stops == 5 ? '00003' : $scope.stops == 6 ? '00004' : null;

    //Add Passenger
    $scope.addPassenger = function () {
        if ($scope.worldTourQuotationData.passengers.length <= 8)
            $scope.worldTourQuotationData.passengers.push({ type: '', firtsName: '', lastName: '', birthDate: '' });
    };

    //Remove Passenger
    $scope.removePassenger = function () {
        if ($scope.worldTourQuotationData.passengers.length > 1) {
            $scope.worldTourQuotationData.passengers.pop();
        }
    };

    //Return true if arg1 is after srg2
    $scope.isDateAfter = function (arg1, arg2) {
        var mArg1, mArg2;
        mArg1 = (typeof (arg1) === "string") ? moment(arg1, "DD/MM/YYYY") : moment(arg1);
        mArg2 = (typeof (arg2) === "string") ? moment(arg2, "DD/MM/YYYY") : moment(arg2);
        return mArg1.isAfter(mArg2);
    };

    //Validate selected dates idDateCalendar: the next idate will be modify
    $scope.validateSegmentsDate = function (dateSegmentMin, idDateCalendar) {
        var dateMax = $scope.dateMax;
        dateSegmentMin = moment(dateSegmentMin, "DD/MM/YYYY");
        dateSegmentMin = moment(dateSegmentMin).format('DD/MM/YYYY');

        var nextInput = parseInt(idDateCalendar.substring(idDateCalendar.length - 1)) + 1;
        $('input', '#i-date-departure-' + nextInput).attr('data-check', "{check:'date',date_min:'" + dateSegmentMin + "',date_max:'" + dateMax + "',birthday:false,nolive:true}");

        if ($('input', '#i-date-departure-' + nextInput).val() != "") {
            if ($scope.isDateAfter(dateSegmentMin, $('input', '#i-date-departure-' + nextInput).val())) {
                $('input', '#i-date-departure-' + nextInput).parent().removeClass("c-field-ok");
                $('input', '#i-date-departure-' + nextInput).parent().addClass("c-field-ko");
            }
            else {
                $('input', '#i-date-departure-' + nextInput).parent().removeClass("c-field-ko");
                $('input', '#i-date-departure-' + nextInput).parent().addClass("c-field-ok");
            }
        }
        if (($scope.stops == 4 || $scope.stops == 6) && nextInput == 2) {
            $('input', '#i-date-departure-4').attr('data-check', "{check:'date',date_min:'" + dateSegmentMin + "',date_max:'" + dateMax + "',birthday:false,nolive:true}");
        }
    };

    //Add On Pacifique
    $scope.clickInAddOn = function (type) {
        if (type) {
            if(type=="pacifique")
            {
                if ($scope.addOnPacifique == false)
                    $scope.addOnPacifique = true;
                else
                    $scope.addOnPacifique = false;

            }
            if (type == "australia") {
                if ($scope.addOnAustralia == false)
                    $scope.addOnAustralia = true;
                else
                    $scope.addOnAustralia = false;
            }
        }
    };

    //Drop
    $scope.callDrop = function (_event, _type) {
        var varIsCountry = (_type == 'country') ? 1 : 0;
        var name = 'i-' + _type;
        var value = $("#ul-" + _type).get(0);
        $window.FSelect({ e: _event, myObj: value, vName: name, isCountry: varIsCountry });
    };

    //Pop
    $scope.callTitlePop = function (_event, _type) {
        var value = _event.target;
        var name = 'i-' + _type + '-pop';
        $window.FPop({ oTarget: value, iPop: name, vStyle: 'classic' });
    };

    //Validate Mandatory Information
    $scope.validateMandatoryInformation = function () {
        return ($scope.worldTourQuotationData.itineraries.length > 1 &&
            $scope.worldTourQuotationData.itineraries.length <= 14 &&
            $scope.worldTourQuotationData.passengers.length >= 1 &&
            $scope.worldTourQuotationData.passengers.length <= 9);
    };

    //Send Request To Api
    $scope.sendWordlTourRequest = function () {
            //if there is not optional stop checked -> remove data check
            if ($scope.stops == 4 && !$scope.addOnPacifique)
            {
                $("#opt1").removeAttr("data-check");
                $("#opt2").removeAttr("data-check");
                $("#i-pacific-arr-text").removeAttr("data-check");
                $("#i-pacific-dep-text").removeAttr("data-check");
            }

            if ($scope.stops == 6 && !$scope.addOnAustralia) {
                $("#optAustralia1").removeAttr("data-check");
                $("#optAustralia2").removeAttr("data-check");
                $("#i-australia-arr-text").removeAttr("data-check");
                $("#i-i-australia-dep-text").removeAttr("data-check");
            }

            if ($window.XLFormValid({ iCont: 'i-form-tour' })) {
                $scope.worldTourQuotationData.itineraries =
                         [{ origin: $scope.auxCities.franceOriginCity, destination: $scope.auxCities.asiaDestinationCity, date: $scope.auxDates.dateDepartureFranceAsia },
                          { origin: $scope.auxCities.asiaOriginCity, destination: $scope.auxCities.newZealandDestionationCity, date: $scope.auxDates.dateDepartureAsiaNZ }];

                if ($scope.validateMandatoryInformation()) {
                    $window.FLoading({ vAction: 'show' });
                    switch ($scope.stops) {
                        case 3:
                            if ($scope.auxCities.newZealandDepartureCity && $scope.auxCities.usaArrivalCity) {
                                $scope.worldTourQuotationData.itineraries.push({ origin: $scope.auxCities.newZealandDepartureCity, destination: $scope.auxCities.usaArrivalCity, date: $scope.auxDates.dateDepartureNewZealand});

                                if ($scope.auxCities.usaDepartureCity && $scope.auxCities.franceArrivalCity)
                                    $scope.worldTourQuotationData.itineraries.push({ origin: $scope.auxCities.usaDepartureCity, destination: $scope.auxCities.franceArrivalCity, date: $scope.auxDates.dateDepartureUsa });
                            }
                            else
                                return;
                            break;
                        case 4:
                            $scope.worldTourQuotationData.itineraries[1].destination = 'Auckland (Nouvelle Zélande)';
                            if ($scope.addOnPacifique) {
                                if ($scope.auxCities.pacificArrivalCity && $scope.auxCities.pacificDepartureCity) {
                                    $scope.worldTourQuotationData.itineraries.push(
                                        {
                                            origin: 'Auckland (Nouvelle Zélande)',
                                            destination: $scope.auxCities.pacificArrivalCity,
                                            date: $scope.auxDates.dateDepartureOptionalPacific
                                        },
                                        {
                                            origin: $scope.auxCities.pacificDepartureCity,
                                            destination: 'Auckland (Nouvelle Zélande)',
                                            date: $scope.auxDates.dateDepartureOptionalNewZealand
                                        }
                                    );
                                }
                                else return;
                            }
                            $scope.worldTourQuotationData.itineraries.push(
                                {
                                    origin: 'Auckland (Nouvelle Zélande)',
                                    destination: 'Buenos Aires (Argentine)',
                                    date: $scope.auxDates.dateDepartureNewZealandBuenosAires
                                },
                                {
                                    origin: 'Buenos Aires (Argentine)',
                                    destination: $scope.auxCities.franceArrivalCity,
                                    date: $scope.auxDates.dateArrivalFrance
                                }
                            );
                            break;
                        case 5:
                            if ($scope.auxCities.pacificLessArrivalCity && $scope.auxCities.pacificLessDepartureCity)
                            {
                                $scope.worldTourQuotationData.itineraries[1].destination = 'Auckland (Nouvelle Zélande)';
                                $scope.worldTourQuotationData.itineraries.push(
                                    {
                                        origin: 'Auckland (Nouvelle Zélande)',
                                        destination: $scope.auxCities.pacificLessArrivalCity,
                                        date: $scope.auxDates.dateDepartureNewZealandPacific
                                    },
                                    {
                                        origin: $scope.auxCities.pacificLessDepartureCity,
                                        destination: 'Los Angeles (Etats-Unis)',
                                        date: $scope.auxDates.dateDeparturePacificUsa
                                    },
                                    {
                                        origin: 'Los Angeles (Etats-Unis)',
                                        destination: 'Londres',
                                        date: $scope.auxDates.dateDepartureUsaUk
                                    },
                                    {
                                        origin: 'Londres',
                                        destination: $scope.auxCities.franceArrivalCity,
                                        date: $scope.auxDates.dateDepartureUkFrance
                                    }
                                );
                            }
                            else return;

                            break;
                        case 6:
                            $scope.worldTourQuotationData.itineraries[1].destination = 'Auckland (Nouvelle Zélande)';
                            if ($scope.addOnAustralia) {
                                $scope.worldTourQuotationData.itineraries.push(
                                    {
                                        origin: 'Auckland (Nouvelle-Zélande)',
                                        destination: $scope.auxCities.australiaArrival,
                                        date: $scope.auxDates.dateDepartureNewZealandAustralia
                                    },
                                    {
                                        origin: $scope.auxCities.australiaDeparture,
                                        destination: 'Auckland (Nouvelle-Zélande)',
                                        date: $scope.auxDates.dateDepartureAustraliaNewZealand
                                    }
                                );
                            }
                            $scope.worldTourQuotationData.itineraries.push(
                                {
                                    origin: 'Auckland (Nouvelle-Zélande)',
                                    destination: $scope.auxCities.pacificLessArrivalCity,
                                    date: $scope.auxDates.dateDepartureNewZealandPacificLess
                                },
                                {
                                    origin: $scope.auxCities.pacificLessDepartureCity,
                                    destination: 'Los Angeles (Etats-Unis)',
                                    date: $scope.auxDates.dateDeparturPacificLessUSA
                                },
                                {
                                    origin: 'Los Angeles (Etats-Unis)',
                                    destination: 'Londres',
                                    date: $scope.auxDates.dateDepartureUsaUk
                                },
                                {
                                    origin: 'Londres',
                                    destination: $scope.auxCities.franceArrivalCity,
                                    date: $scope.auxDates.dateDepartureUkFrance
                                }
                            );
                    }

                    //Call rest api transaction
                    $scope.request = { tdm: $scope.worldTourQuotationData };
                    $scope.apiClient.B2B.sendRequests($scope.request).success(function (response) {
                        $window.FLoading({ vAction: 'hide' });
                        if (response && response.status==0) {
                            $scope.sent = true;
                        }
                        else {
                            $window.XLConfirm({
                                vTitle: "Erreur dans l'enregistrement, veuillez recommencer",
                                vTextYes: 'OK Merci',
                                vHideNo: true
                            });
                        }
                    }).error(function () {
                        $window.FLoading({ vAction: 'hide' });
                        $window.XLConfirm({
                            vTitle: "Erreur dans l'enregistrement, veuillez recommencer",
                            vTextYes: 'OK Merci',
                            vHideNo: true
                        });
                    });
                }
            }
        };
}]);
